<template>
  <div>
    <div class="panel-block is-flex is-justify-content-space-between custom-panel estimage-panel-border pb-3"
      :class="[{'custom-panel-with-no-chart': isUninvoicedJobsAndChartDisabled}]">
      <p class="is-flex is-align-items-center">EstImage</p>
    </div>
    <div class="panel-block custom-panel">
      <div class="column message-item clickable-message"
        @click="onClick(messageStatusTypes.UnRead)">
        <span class="is-size-7">Inbox</span>
        <DashboardWebServiceCircularStatus :value="estimage?.unRead"
          :color-code="getButtonColorCode(estimage?.unRead, isGreen)"
          :width="'40px'"
          :height="'40px'" />
      </div>
      <div class="column message-item clickable-message"
        @click="onClick(messageStatusTypes.ToSend)">
        <span class="is-size-7">Failed</span>
        <DashboardWebServiceCircularStatus :value="estimage?.sendFailed"
          :color-code="getButtonColorCode(estimage?.sendFailed, isRed)"
          :width="'40px'"
          :height="'40px'" />
      </div>
      <div class="column message-item clickable-message"
        @click="onClick(messageStatusTypes.ToSend)">
        <span class="is-size-7">Outbox</span>
        <DashboardWebServiceCircularStatus :value="estimage?.toSend"
          :color-code="getButtonColorCode(estimage?.toSend, isGray)"
          :width="'40px'"
          :height="'40px'" />
      </div>
      <div class="column message-item clickable-message"
        @click="onClick(messageStatusTypes.SyncFailed)">
        <span class="is-size-7">Sync Fail</span>
        <DashboardWebServiceCircularStatus :value="estimage?.syncFailed"
          :color-code="getButtonColorCode(estimage?.syncFailed, isRed)"
          :width="'40px'"
          :height="'40px'" />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardWebServiceCircularStatus from '@/views/dashboard/DashboardWebServiceCircularStatus.vue'
import messageStatusTypes from '@/enums/MessageStatusTypes'
import { Columns } from '@/views/pnetmessage/columns'

export default {
  name: 'DashboardEstimage',
  components: { DashboardWebServiceCircularStatus },

  props: {
    estimage: null,
    isUninvoicedJobsAndChartDisabled: Boolean
  },
  data() {
    return {
      isGreen: '#54B700',
      isRed: '#D92550',
      isGray: '#495057',
      filter: {
        quoteNo: '',
        rego: '',
        claimNo: '',
        messageTypeId: 0,
        messageStatusId: this.tab,
        sortColumn: Columns[Columns.length - 2].name,
        sortOrder: Columns[Columns.length - 2].defaultOrder,
        pageIndex: 1,
        pageSize: 18
      }
    }
  },
  computed: {
    messageStatusTypes() {
      return messageStatusTypes
    },
    filterKey() {
      if (!this.$userInfo) return ''
      return `${this.$userInfo.sessionId}|estimagemessage|filter`
    }
  },
  beforeDestroy() {
    if (this.timeOutId) clearTimeout(this.timeOutId)
  },
  methods: {
    getButtonColorCode(value, color) {
      if (value > 0) return color
      return this.isGray
    },
    onClick(tab) {
      const obj = {
        ...this.filter,
        messageStatusId: tab
      }
      sessionStorage.setItem(this.filterKey, JSON.stringify(obj))
      this.$router.push('estimageMessages')
    }
  }
}
</script>

<style scoped>
.custom-panel {
  color: #fff;
}

.custom-panel:last-child {
  border-radius: 0px 0px 20px 20px !important;
}

.custom-panel-with-no-chart {
  color: #fff;
  height: 10vh;
}

.custom-panel-border:not(:last-child) {
  border-bottom: 1px solid black;
}
.tile-border {
  border-radius: 20px !important;
}

.custom-panel-heading {
  border-radius: 20px 20px 0 0 !important;
  background-color: #495057 !important;
}

.estimage-panel-border:not(:last-child) {
  border-bottom: 1px solid #bda448;
}

.message-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.clickable-message {
  cursor: pointer;
  border: 1px transparent solid;
  opacity: 1;
}

.clickable-message:hover {
  background: linear-gradient(to right, #222 50%, hsl(0, 0%, 8%) 50%);
  background-size: 200% 120%;
  background-position: right;
}
</style>